//side menu
export const visitorsListIcon = "pe-7s-id";
export const visitorsMainIcon = "pe-7s-id icon-gradient bg-mixed-hopes";
export const customersListIcon = "pe-7s-user";
export const receiverIcon = "lnr-user icon-gradient bg-mixed-hopes";
export const receiversIcon = "lnr-user";
export const receiverMainIcon = "pe-7s-user icon-gradient bg-mixed-hopes";
export const customersMainIcon = "pe-7s-id icon-gradient bg-mixed-hopes";
export const sharingLogIcon = "pe-7s-folder";
export const cbkIcon = "pe-7s-global";
export const usersIcon = "pe-7s-users";
export const usersMainIcon = "pe-7s-users icon-gradient bg-mixed-hopes";
export const note2Icon = "pe-7s-note2";
export const note2MainIcon = "pe-7s-note2 icon-gradient bg-mixed-hopes";
export const contentManagementIcon = "pe-7s-tools";
export const notificationsIcon = "pe-7s-mail-open-file";
export const settingsIcon = "pe-7s-config";
export const statisticsIcon = "pe-7s-graph3";
export const appsIcon = "pe-7s-settings";
export const dashboardMainIcon = "pe-7s-monitor icon-gradient bg-mixed-hopes";
export const dictionariesMainIcon =
  "pe-7s-notebook icon-gradient bg-mixed-hopes";
export const dictionaryIcon = "pe-7s-notebook";
export const toggleDownIcon = "pe-7s-angle-down";
export const toggleUpIcon = "pe-7s-angle-up";
export const toggleRightIcon = "pe-7s-angle-right";
export const dictionariesMenuIcon = "pe-7s-notebook";
export const photoGalleryIcon = "pe-7s-photo-gallery";
export const photoGalleryMainIcon =
  "pe-7s-photo-gallery icon-gradient bg-mixed-hopes";
export const fileIcon = "pe-7s-file";
export const mainDetailsIcon = "pe-7s-file icon-gradient bg-mixed-hopes";
export const refreshIcon = "pe-7s-refresh";
export const deleteIcon = "pe-7s-trash";
export const plusIcon = "lnr-plus-circle";
export const filterIcon = "fas fa-filter";
export const crossCircleIcon = "lnr-cross-circle";
export const cloundUploadIcon = "lnr-cloud-upload";
export const addIcon = "pe-7s-plus";
export const paperPlaneIcon = "pe-7s-paper-plane";
export const parametersIcon = "pe-7s-config";
export const addUserIcon = "pe-7s-add-user";
export const editIcon = "pe-7s-edit";
export const copyFileIcon = "pe-7s-copy-file";
export const deleteUserIcon = "pe-7s-delete-user";
export const saveIcon = "pe-7s-diskette";
export const backIcon = "pe-7s-back";
export const smsIcon = "pe-7s-comment";
export const platformIcon = "pe-7s-cloud";
export const signalmanIcon = "pe-7s-display2";
export const pushIcon = "pe-7s-phone";
export const mailIcon = "pe-7s-mail";
export const clockIcon = "pe-7s-clock";
export const pencilIcon = "lnr-pencil";
export const checkIcon = "pe-7s-check";
export const leftCircleIcon = "pe-7s-angle-left-circle";
export const folderIcon = "pe-7s-folder";
export const cancelIcon = "lnr-undo";
export const closeCirleIcon = "pe-7s-close-circle";
export const attachmentIcon = "lnr-file-add icon-gradient bg-mixed-hopes";
export const agreementMainIcon = "lnr-warning icon-gradient bg-mixed-hopes";
export const templateMainIcon = "pe-7s-note2 icon-gradient bg-mixed-hopes";
export const templateSendingMainIcon =
  "pe-7s-mail-open-file icon-gradient bg-mixed-hopes";
export const configurationChannelMainIcon =
  "pe-7s-config icon-gradient bg-mixed-hopes";
export const statisticsMainIcon = "pe-7s-graph3 icon-gradient bg-mixed-hopes";
export const settingsMainIcon = "pe-7s-config icon-gradient bg-mixed-hopes";
export const menuIcon = "pe-7s-menu";
export const shareIcon = "pe-7s-share";
export const printIcon = "lnr-printer";
export const listIcon = "lnr-list";
export const listMainIcon = "pe-7s-list icon-gradient bg-mixed-hopes";
export const ePuapDataIcon = "pe-7s-next-2";
export const jobInformationIcon = "pe-7s-wallet";
export const consentAndRegulationIcon = "pe-7s-like2";
export const handIcon = "lnr-hand";
export const downloadIcon = "lnr-download";
export const checkmarkIcon = "lnr-checkmark-circle";
export const likeIcon = "pe-7s-like";
export const likeMainIcon = "pe-7s-like icon-gradient bg-mixed-hopes";
export const starIcon = "pe-7s-star";
export const starMainIcon = "pe-7s-star icon-gradient bg-mixed-hopes";
export const searchIcon = "pe-7s-search";
export const cashIcon = "pe-7s-cash";
export const cashMainIcon = "pe-7s-cash icon-gradient bg-mixed-hopes";
export const calculatorIcon = "pe-7s-calculator";
export const calculatorMainIcon =
  "pe-7s-calculator icon-gradient bg-mixed-hopes";
export const cartIcon = "pe-7s-cart";
export const display2MainIcon = "pe-7s-display2 icon-gradient bg-mixed-hopes";
export const cultureIcon = "pe-7s-culture";

export const configurationSmsMainIcon =
  "pe-7s-comment icon-gradient bg-mixed-hopes";
export const configurationPushMainIcon =
  "pe-7s-phone icon-gradient bg-mixed-hopes";
export const configurationMailMainIcon =
  "pe-7s-mail icon-gradient bg-mixed-hopes";
export const bellIcon = "pe-7s-bell";
export const bellMainIcon = "pe-7s-bell icon-gradient bg-mixed-hopes";

export const newsPaperIcon = "pe-7s-news-paper";
export const briefCaseIcon = "lnr lnr-briefcase";
export const briefCaseMainIcon =
  "lnr lnr-briefcase icon-gradient bg-mixed-hopes";
export const bipIcon = "pe-7s-culture icon-gradient bg-mixed-hopes-tiles";
export const eBoiIcon = "pe-7s-monitor icon-gradient bg-mixed-hopes-tiles";
export const boIcon = "pe-7s-server icon-gradient bg-mixed-hopes-tiles";
export const spIcon = "pe-7s-ribbon icon-gradient bg-mixed-hopes-tiles";
export const eRejestryIcon = "pe-7s-note2 icon-gradient bg-mixed-hopes-tiles";
export const eFormularze =
  "pe-7s-photo-gallery icon-gradient bg-mixed-hopes-tiles";
export const docRepoIcon = "pe-7s-map icon-gradient bg-mixed-hopes-tiles";
export const customerFilterIcon = "pe-7s-filter";
export const photoIcon = "pe-7s-photo";
export const photoMainIcon = "pe-7s-photo icon-gradient bg-mixed-hopes";
export const lockIcon = "pe-7s-lock";
export const unLockIcon = "pe-7s-unlock";
export const moreIcon = "pe-7s-more";
export const userIcon = "lnr-user";
export const enterIcon = "lnr lnr-enter";
export const historyIcon = "lnr lnr-history";
export const networkIcon = "pe-7s-network";
export const networkMainIcon = "pe-7s-network icon-gradient bg-mixed-hopes";
export const infoIcon = "pe-7s-info";

export const formIcon = "pe-7s-notebook icon-gradient bg-mixed-hopes";
export const arrowDown = "pe-7s-angle-down";
export const arrowUp = "pe-7s-angle-up";

export const lookIcon = "pe-7s-look";

export const signIcon = "pe-7s-pen";

export const mapIcon = "pe-7s-map-2";

export const globalIcon = "pe-7s-global";
